import * as React from "react";
import * as ReactDOM from "react-dom";
import {TopicConfiguration} from "../../../config/topic-configuration";

export interface TitleProps {
    pageTitle?: string;
    siteTitle?: string;
    topic?: TopicConfiguration | undefined;
    subtopic?: TopicConfiguration | undefined;
}

export class Title extends React.Component<TitleProps, any> {
    siteTitle: string;
    titleEl: any;
    ogTitle: HTMLElement | null;
    descriptionEl: HTMLElement | null;
    ogDescription: HTMLElement | null;

    constructor(props: TitleProps) {
        super(props);
        if (this.props.siteTitle) {
            this.siteTitle = this.props.siteTitle;
        } else {
            this.siteTitle = "Onlinekarte";
        }
        this.titleEl = document.getElementsByTagName("title")[0];
        this.ogTitle = document.querySelector("meta[property='og:title']");
        this.descriptionEl = document.querySelector("meta[name='description']");
        this.ogDescription = document.querySelector("meta[property='og:description']");
    }

    render() {
        let fullTitle;
        if (this.props.siteTitle) {
            this.siteTitle = this.props.siteTitle;
        }
        if (this.props.pageTitle) {
            fullTitle = this.siteTitle + " - " + this.props.pageTitle;
        } else {
            fullTitle = this.siteTitle;
        }
        if (typeof this.props.subtopic?.description === "string" && this.props.subtopic?.description !== "") {
            this.descriptionEl?.setAttribute("content", this.props.subtopic?.description as string);
            this.ogDescription?.setAttribute("content", this.props.subtopic?.description as string);
        }else if (typeof this.props.topic?.description === "string" && this.props.topic?.description !== "") {
            this.descriptionEl?.setAttribute("content", this.props.topic?.description as string);
            this.ogDescription?.setAttribute("content", this.props.topic?.description as string);
        }
        this.ogTitle?.setAttribute("content", fullTitle || "");
        return ReactDOM.createPortal(
            fullTitle || "",
            this.titleEl
        );
    }
}
